import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import Button from "./button";

interface CheckboxProps {
    onClick: () => void;
    checked: boolean;
    label?: string;
}

export default function Checkbox({ onClick, checked, label }: CheckboxProps) {
    const [isChecked, setIsChecked] = useState<boolean>(checked);

    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    return (
        <Button
            variant="ghost"
            size="ghost"
            onClick={() => {
                setIsChecked(!isChecked);
                onClick();
            }}>
            <div className="flex h-5 w-5 flex-shrink-0 items-center justify-center rounded border border-slate-300 ring-offset-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-200 focus-visible:ring-offset-2 disabled:cursor-not-allowed  disabled:opacity-5 dark:border-slate-700 dark:ring-offset-slate-900 focus-visible:dark:ring-slate-700">
                {isChecked && (
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={4} stroke="currentColor" className="h-3 w-3 text-slate-800 dark:text-slate-200">
                        <motion.path strokeLinecap="round" strokeLinejoin="round" initial={{ pathLength: 0 }} animate={{ pathLength: 1 }} transition={{ duration: 0.3 }} d="M4.5 12.75l6 6 9-13.5" />
                    </svg>
                )}
            </div>
            {label && <div>{label}</div>}
        </Button>
    );
}
